import React, { Suspense } from 'react';
import Navbar from './components/Navbar';
import { SEO } from './components/SEO';
import ScrollToTop from './components/ScrollToTop';
import siteSchema from './public/data/site_schema.json';
import CustomCursor from './components/CustomCursor';
import { useSmoothScroll } from './hooks/useSmoothScroll';
import { useScrollAnimations } from './hooks/useScrollAnimations';
import { useRoutes } from 'react-router-dom';
import { routes } from './routes';
const App: React.FC = () => {
  useSmoothScroll();
  useScrollAnimations();
  const element = useRoutes(routes);

  React.useEffect(() => {
    // Tell the pre-renderer that the page is ready
    const timer = setTimeout(() => {
      document.dispatchEvent(new Event('custom-render-trigger'));
    }, 1000); // Give a bit of extra time for heavy assets
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen text-zinc-100 selection:bg-neon-blue selection:text-white cursor-none">
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <CustomCursor />
      {/* Global Atmosphere */}
      <div className="lava-background" />

      {/* Grain Overlay (Global) */}
      <div className="fixed inset-0 pointer-events-none opacity-[0.03] mix-blend-overlay z-[9999] bg-[url('https://grainy-gradients.vercel.app/noise.svg')]" />
      {/* Grain Overlay (Global) */}
      <div className="fixed inset-0 pointer-events-none opacity-[0.03] mix-blend-overlay z-[9999] bg-[url('https://grainy-gradients.vercel.app/noise.svg')]" />

      <Navbar />
      <ScrollToTop />
      <main id="main-content">
        <Suspense fallback={
          <div className="min-h-screen flex items-center justify-center">
            <div className="text-center">
              <div className="w-16 h-16 border-4 border-neon-blue border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
              <p className="text-neutral-500">Loading...</p>
            </div>
          </div>
        }>
          {element}
        </Suspense>
      </main>
    </div>
  );
};

export default App;